import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

import type { MatterArtifactSelectionAttachment } from '@/agent-v2/artifact-selection/types'
import { AgentV2ConversationsActions } from '@/agent-v2/conversations/store/slice'

export type MatterArtifactSelectionState = {
  attachmentsByConversationId: Partial<Record<string, MatterArtifactSelectionAttachment>>
}

const initialState: MatterArtifactSelectionState = {
  attachmentsByConversationId: {},
}

const matterArtifactSelectionSlice = createSlice({
  name: 'matterArtifactSelectionState',
  initialState,
  reducers: {
    attachMatterArtifactSelection: (
      state,
      action: PayloadAction<{
        conversationId: string
        attachment: MatterArtifactSelectionAttachment
      }>
    ) => {
      state.attachmentsByConversationId[action.payload.conversationId] = action.payload.attachment
    },
    clearMatterArtifactSelection: (state, action: PayloadAction<{ conversationId: string }>) => {
      delete state.attachmentsByConversationId[action.payload.conversationId]
    },
    nullifyData: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(AgentV2ConversationsActions.runTerminalObserved, (state, action) => {
        delete state.attachmentsByConversationId[action.payload.conversationId]
      })
      .addCase(AgentV2ConversationsActions.runDidNotStart, (state, action) => {
        delete state.attachmentsByConversationId[action.payload.conversationId]
      })
      // A reread that shows the edit's turn ended clears the selection in the conversation
      // listeners, which can see whether a run is still starting or running.
      .addCase(AgentV2ConversationsActions.deleteConversation, (state, action) => {
        delete state.attachmentsByConversationId[action.payload.conversationId]
      })
      .addCase(AgentV2ConversationsActions.nullifyData, () => initialState)
  },
})

export const MatterArtifactSelectionActions = matterArtifactSelectionSlice.actions
export default matterArtifactSelectionSlice.reducer
